module.exports = __webpack_public_path__ + "media/images/admin/icons/thermometer-3f4fcca9a253990f6a685179eb50bec4.svg";